import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiProfilePrimaryQueryResponse,
  GetApiProfilePrimaryQueryParams,
  GetApiProfilePrimary401,
  GetApiProfilePrimary403,
} from "../../../types/GetApiProfilePrimary";

export function getGetApiProfilePrimaryUrl() {
  return `/api/Profile/primary` as const;
}

/**
 * {@link /api/Profile/primary}
 */
export async function getApiProfilePrimary(
  params?: GetApiProfilePrimaryQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiProfilePrimaryQueryResponse,
    ResponseErrorConfig<GetApiProfilePrimary401 | GetApiProfilePrimary403>,
    unknown
  >({
    method: "GET",
    url: getGetApiProfilePrimaryUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
